import React from "react";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";

const parseTime = (s) => {
    if (!s || typeof s !== "string") return null;
    const trimmed = s.trim();
    if (!trimmed) return null;
    const [hPart, mPart] = trimmed.split(":");
    const h = parseInt(hPart, 10);
    const m = parseInt(mPart !== undefined ? mPart : "0", 10);
    if (!Number.isInteger(h) || h < 0 || h > 23) return null;
    if (!Number.isInteger(m) || m < 0 || m > 59) return null;
    const hhmm = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    const d = dayjs(`1970-01-01T${hhmm}`);
    return d.isValid() ? d : null;
};

const AppTimePicker = ({
    label,
    name,
    value,
    onChange,
    helperText,
    error = false,
    required = false,
    disabled = false,
    fullWidth = true,
    size = "medium",
    slotProps,
    ...rest
}) => {
    const handleChange = (next) => {
        if (typeof onChange !== "function") return;
        if (next && dayjs.isDayjs(next) && next.isValid()) {
            onChange(next.format("HH:mm"), name);
        } else {
            onChange("", name);
        }
    };

    const callerTextFieldSlot = (slotProps && slotProps.textField) || {};
    const mergedSlotProps = {
        ...(slotProps || {}),
        textField: {
            name,
            fullWidth,
            size,
            required,
            error,
            helperText,
            ...callerTextFieldSlot,
        },
    };

    return (
        <TimePicker
            label={label}
            value={parseTime(value)}
            onChange={handleChange}
            ampm={false}
            disabled={disabled}
            slotProps={mergedSlotProps}
            {...rest}
        />
    );
};

export default AppTimePicker;
